import React from 'react';
import { Section } from './ui/Section';
import { Smartphone, Pill, Lightbulb } from 'lucide-react';
export function WhyOldSolutionsFail() {
  const solutions = [{
    icon: <Smartphone className="text-[#d4a574]" size={32} data-id="element-201" />,
    title: 'Apps/meditación',
    text: 'útiles, pero a esa hora estás sin energía. Mucha fricción.'
  }, {
    icon: <Pill className="text-[#d4a574]" size={32} data-id="element-202" />,
    title: 'Suplementos',
    text: 'pueden bajar el cuerpo, pero no apagan el tablero mental.'
  }, {
    icon: <Lightbulb className="text-[#d4a574]" size={32} data-id="element-203" />,
    title: 'Tips sueltos',
    text: "no entrenan un hábito. No crean una señal de 'cierre'."
  }];
  return <Section background="navy" data-id="element-204">
      <h2 className="text-3xl md:text-4xl font-serif text-center text-white mb-16" data-id="element-205">
        Por qué lo que probaste no se pegó
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-206">
        {solutions.map((item, index) => <div key={index} className="bg-[#0f172a] p-8 rounded-xl border border-white/5 hover:border-[#d4a574]/30 transition-colors duration-300" data-id="element-207">
            <div className="mb-6 bg-[#1e1b4b] w-16 h-16 rounded-full flex items-center justify-center" data-id="element-208">
              {item.icon}
            </div>
            <h3 className="text-xl font-serif text-white mb-3" data-id="element-209">{item.title}</h3>
            <p className="text-slate-400 leading-relaxed" data-id="element-210">{item.text}</p>
          </div>)}
      </div>

      <div className="mt-16 text-center" data-id="element-211">
        <p className="text-2xl font-serif text-white" data-id="element-212">
          Tu noche necesita un{' '}
          <span className="text-[#d4a574] italic" data-id="element-213">"sistema operativo"</span>.
          <br data-id="element-214" />
          <span className="text-slate-400 text-xl mt-2 block" data-id="element-215">
            No un consejo suelto.
          </span>
        </p>
      </div>
    </Section>;
}